/*/ ## EF.Collections.ActionPlanTopicsCollection
//
// Collection for action plan topics
*/
(function(EF, undefined) {

  var ActionPlanTopicsCollection = Chaplin.Collection.extend({
    model: EF.Models.ActionPlanItem,
    fileName: 'action_plan_topics.json',

    initialize: function(models, options) {
      this.enrollment = options.enrollment;
      this.actionPlanItemResponses = options.actionPlanItemResponses;
    },

    url: function() {
      return EF.url('/sdk/enrollments/' + this.enrollment.get('id') +'/' + this.fileName + '?' + $.param(this.params || {}));
    },

    fetchWithResponses: function(moduleKey) {
      this.params = { module_key: moduleKey };
      return this.fetch().then(_.bind(this.fetchActionPlanItemResponses, this));
    },

    fetchActionPlanItemResponses: function() {
      var deferred = $.Deferred(), self = this;
      this.actionPlanItemResponses.fetchWithParams(this.params).done(function() {
        deferred.resolve(self.actionPlanItemResponses);
      });
      return deferred.promise();
    }

  });


  _.extend(EF.Collections, {
    ActionPlanTopicsCollection: ActionPlanTopicsCollection
  });

})(EF);
